var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cont-1"},[_c('h3',[_vm._v("The Admin is temporarily not available.")])])
}]

export { render, staticRenderFns }